import { deepExtract } from 'helpers/deep';
import { SEARCH_BOX_WRITE_ACTIONS } from './SearchBox.reducer';

// The location field works with location items from both the autocomplete
// API, and the history API which return slightly different shapes. This fn
// returns a standard representation of a location item for the `Location`
// component to render.
export const getItemNormalizer = itemType => item => ({
  lat: item.lat,
  lon: item.lon,
  location_id: item.location_id,
  place_id: item.place_id || item.google_place_id,
  main_text: item.main_text || item.name,
  secondary_text: item.secondary_text || item.formatted_address,
  type: itemType,
  timezone: item.timezone,
  calculated_radius_km: item.calculated_radius_km,
  calculated_radius_miles: item.calculated_radius_miles,
});

export const selectSearchBoxWriteActions = action =>
  SEARCH_BOX_WRITE_ACTIONS.includes(action.type) && !deepExtract('data.options.excludeFromWriteActions', action);
